"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = !0;
exports.ClickableImg = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var ClickableImg = _styledComponents.default.img.withConfig({
  displayName: "ClickableImg",
  componentId: "sc-vbcsa1-0"
})(["cursor:pointer;padding-left:0.5rem;padding-right:0.5rem;margin:auto;height:15px;"]);

exports.ClickableImg = ClickableImg;